module.exports = __webpack_public_path__ + "img/34.dbcfd96e.png";